import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '#pplx/frontend/aether/components/Button/index.js';
import { Link } from '#pplx/frontend/aether/components/Link/index.js';
import { useIsInsideTabsActions } from '#pplx/frontend/aether/components/Tabs/internal/useTabsStructure.js';
/** Renders a strict Tabs action as an Aether Button or Link. */
export function TabsAction(props) {
    const isInsideActions = useIsInsideTabsActions();
    if (!isInsideActions) {
        throw new Error('Tabs.Action must be used within Tabs.Actions');
    }
    const { variant } = props;
    if (props.icon !== undefined) {
        return (_jsx(Button, { variant: variant, size: "small", onClick: props.onClick, expanded: props.expanded, track: props.track, icon: props.icon, "aria-label": props['aria-label'] }));
    }
    if (props.href !== undefined) {
        return (_jsx(Link, { href: props.href, variant: variant, size: "small", track: props.track, children: props.children }));
    }
    return (_jsx(Button, { variant: variant, size: "small", onClick: props.onClick, track: props.track, children: props.children }));
}
//# sourceMappingURL=TabsAction.js.map